<template>
  <div class="container">
    <table class="table table-borderless">
      <tbody class="body">
        <tr>
          <td class="col-6 head">Transfer Batch No.</td>
          <td class="col-6 head">Content Type</td>
        </tr>
        <tr>
          <td class="content">
            {{ contentStore.currentContent.name }}
          </td>
          <td class="content">{{ contentStore.currentContent.contentType }}</td>
        </tr>
        <tr>
          <td class="head">Date Received</td>
          <td class="head">Status</td>
        </tr>
        <tr>
          <td class="content">
            {{
              $filters.formatDateAndTime(
                contentStore.currentUnknownContent.depositedAt
              )
            }}
          </td>
          <td class="content">
            {{ contentStore.currentContent.status }}
          </td>
        </tr>
        <!-- <tr>
          <td class="head">Transferring Agency</td>
        </tr> -->
        <!-- <tr>
          <td class="content">
            {{ contentStore.currentContent.transferringAgency }}
          </td>
        </tr> -->
        <tr>
          <td class="head">Error Message</td>
        </tr>
        <tr>
          <td class="content">The transfer package is wrongly named</td>
        </tr>
        <tr>
          <td class="head">Report</td>
        </tr>
        <tr>
          <td class="content">
            <button
              class="btn btn-download btn-primary"
              @click="downloadReportPdf"
            >
              Download Report Summary
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { useContentStore } from "@/stores/content_review/content";
import { usePDFuknown } from "@/stores/report_pdf_unknown";
import { useAudit } from "@/stores/audit";
import { useAsyncState } from "@vueuse/core";
import { watch } from "vue";

const contentStore = useContentStore();
const pdfStore = usePDFuknown();
const audit = useAudit();

watch(
  () => props.contentId,
  () => execute()
);

const props = defineProps({
  contentId: { type: String },
});

const { execute, error } = useAsyncState(() => {
  return contentStore.fetchUnknownContent(contentStore.currentContent.id);
}, null);

const downloadReportPdf = async () => {
  audit.auditLog("Transfer Report Unknown")
  pdfStore.downloadPDF(contentStore.currentContent);
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  padding: 16px;
  min-width: 100%;
  overflow: auto;
}
</style>
